export default __webpack_public_path__ + "static/media/tataki.bdbaa9ce.jpg";